import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'providerManagement',
  initialState: {
    scanCenterList: [],
    scanCenterLoading: false,
  },
  reducers: {
    getScanCenterList: (state, { payload }) => {
      state.scanCenterLoading = true
    },
    getScanCenterDataSuccess: (state, { payload }) => {
      state.scanCenterLoading = false
      state.scanCenterList = payload?.payload?.data
    },
    getScanCenterDataFailed: (state, { payload }) => {
      // Handle failure logic here
      state.scanCenterLoading = false
    },
  },
})

export const { getScanCenterList, getScanCenterDataSuccess, getScanCenterDataFailed } = slice.actions

export default slice.reducer
